export function flattenTreeToKeyValue(tree: any, keyField: string, valueField: string, childrenField: 'children'): {[key: string]: any} {
    function recurse(node: any) {
        let result: {[key: string]: any} = {};
        if (node[keyField] && node[valueField]) {
            result[node[keyField]] = node[valueField];
        }
        if (node[childrenField] && Array.isArray(node[childrenField])) {
            for (let child of node[childrenField]) {
                const childResult = recurse(child);
                result = { ...result, ...childResult };
            }
        }
        return result;
    }

    const keyValueObject = recurse(tree);
    return keyValueObject;
}